@if (entry.base?.display) {
  <form
    [connect]="'payloadStates.' + entry?.formControlAttributes?.connectPath"
    class="question-class"
    [formGroup]="form"
    >
    <mat-form-field appearance="outline">
      <mat-label>{{entry?.formControlAttributes?.label}}@if (valueRequired) {
        <span style="color: #a71919;">*</span>
      }</mat-label>
      <mat-select
        [formControlName]="entry?.formControlAttributes?.formControlName"
        [id]="entry?.formControlAttributes?.formControlName"
        >
        @for (option of entry?.selectAttributes?.optionAttributes; track option) {
          <mat-option [value]="option.value">{{option.label}}</mat-option>
        }
      </mat-select>
      @if (formControls[entry?.formControlAttributes?.formControlName]?.errors?.required) {
        <mat-error>Required</mat-error>
      }
    </mat-form-field>
  </form>
}

